if (!window.featuredProductGalleryScriptLoaded) {
	window.featuredProductGalleryScriptLoaded = true

	async function refreshCartUI() {
		// Ask Shopify to re-render server-side sections and return fresh HTML
		const sectionsToRender = ["cart-drawer", "cart-icon-bubble"] // adjust to your theme
		const res = await fetch(`${window.location.pathname}?sections=${sectionsToRender.join(",")}`)
		const sectionsHTML = await res.json()
		const parser = new DOMParser()

		// Replace Cart Drawer
		if (sectionsHTML["cart-drawer"]) {
			const newDoc = parser.parseFromString(sectionsHTML["cart-drawer"], "text/html")
			const newDrawer = newDoc.querySelector("cart-drawer") || newDoc.body.firstElementChild
			const oldDrawer = document.querySelector("cart-drawer")
			if (oldDrawer && newDrawer) oldDrawer.replaceWith(newDrawer)
		}

		// Replace Cart Icon Bubble / Header Count
		if (sectionsHTML["cart-icon-bubble"]) {
			const newDoc = parser.parseFromString(sectionsHTML["cart-icon-bubble"], "text/html")
			const newBubble = newDoc.getElementById("cart-icon-bubble")
			const oldBubble = document.getElementById("cart-icon-bubble")
			if (oldBubble && newBubble) oldBubble.replaceWith(newBubble)
		}
	}

	function bindExpandButtons(container = document) {
		container.addEventListener("click", (e) => {
			const toggle = e.target.closest(".product-card .product-link")
			if (!toggle || !container.contains(toggle)) return

			// This link is acting as a toggle, don't navigate
			e.preventDefault()

			const card = toggle.closest(".product-card")
			const details = card?.querySelector(".product-listing-details")
			const label = toggle.querySelector(".product-link-button-text")

			if (!details) return

			// Use the details panel as the single source of truth
			const isCollapsed = details.classList.contains("collapsed")
			details.classList.toggle("collapsed", !isCollapsed)
			toggle.classList.toggle("expand", isCollapsed)

			// Accessibility states
			toggle.setAttribute("aria-expanded", String(isCollapsed))
			details.setAttribute("aria-hidden", String(!isCollapsed))

			if (label) {
				label.textContent = isCollapsed ? "Hide Details" : "Learn More"

				setTimeout(() => {
					if (isCollapsed) {
						const rect = label.getBoundingClientRect()
						const fullyVisible =
							rect.top >= 0 &&
							rect.bottom <= (window.innerHeight || document.documentElement.clientHeight)

						if (!fullyVisible)
							label.scrollIntoView({
								behavior: "smooth",
								block: "end",
							})
					}
				}, 500)
			}
		})
	}

	function bindProductForms(root = document) {
		root.querySelectorAll(".product-form").forEach((form) => {
			if (form.dataset.bound === "true") return
			form.dataset.bound = "true"

			form.addEventListener("submit", async (e) => {
				e.preventDefault()

				const button = form.querySelector(".add-to-cart-action-button")
				const addUrl = form.dataset.cartAddUrl || "/cart/add.js"

				// main variant
				const variantId = form.dataset.variantId || form.querySelector('[name="id"]')?.value

				// 👇 NEW: theft protection variant
				const theftProtectionId = form.dataset.theftProtectionId

				// selling plan logic
				const requiresPlan = form.dataset.requiresSellingPlan === "true"
				let sellingPlanId = form.dataset.variantSellingPlanId || ""

				if (!sellingPlanId && requiresPlan) {
					// fallback to product-level first plan if variant allocation wasn’t present
					sellingPlanId = form.dataset.productSellingPlanId || ""
				}

				// 👇 CHANGED: build items array instead of single-line payload
				const items = []

				const mainItem = {
					id: Number(variantId),
					quantity: 1,
				}

				if (sellingPlanId) {
					mainItem.selling_plan = Number(sellingPlanId)
				}

				items.push(mainItem)

				// 👇 NEW: add theft protection as a second line item, if configured
				if (theftProtectionId) {
					items.push({
						id: Number(theftProtectionId),
						quantity: 1,
					})
				}

				const payload = { items }

				const prevText = button.textContent
				button.disabled = true
				button.textContent = "Adding..."

				try {
					const response = await fetch(addUrl, {
						method: "POST",
						headers: {
							"Content-Type": "application/json",
							Accept: "application/json",
						},
						body: JSON.stringify(payload),
					})
					if (!response.ok) throw new Error(await response.text())
					await response.json()

					await refreshCartUI()
					document.querySelector("cart-drawer")?.open?.()
					document.dispatchEvent(new CustomEvent("cart:updated"))
					button.textContent = "Added!"
				} catch (err) {
					console.error("Add to cart failed:", err)
					button.textContent = "Error"
				} finally {
					setTimeout(() => {
						button.textContent = prevText
						button.disabled = false
					}, 1200)
				}
			})
		})
	}

	document.addEventListener("DOMContentLoaded", () => {
		bindProductForms()
		bindExpandButtons()
	})
	// Make it work inside Theme Editor live reloads
	document.addEventListener("shopify:section:load", (e) => bindProductForms(e.target))
	document.addEventListener("shopify:section:select", (e) => bindProductForms(e.target))
}
